import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { IauiVerificationAction } from "@obg/ngx.common";
import { BankDetailsVerificationStatus, CoreState, CustomerManagementSelector } from "@obg/ngx.core";
import { ignoreNil } from "@obg/rxjs";
import { map } from "rxjs/operators";

@Component({
	selector: "obg-m-iaui-notification",
	templateUrl: "./iaui-notification.component.html",
	styleUrls: ["./iaui-notification.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class IauiNotificationComponent {
	@HostBinding("class.obg-m-iaui-notification") hostCssClass = true;

	pending = BankDetailsVerificationStatus.Pending;
	denied = BankDetailsVerificationStatus.Denied;

	bankDetailsVerificationStatus$ = this.store.select(CustomerManagementSelector.getCustomer).pipe(
		ignoreNil(),
		map((customer) => customer.profile.bankDetailsVerificationStatus)
	);

	constructor(
		private store: Store<CoreState>,
		private iauiVerificationAction: IauiVerificationAction
	) {}

	verify() {
		this.store.dispatch(this.iauiVerificationAction.openModal());
	}

	dismiss() {
		this.store.dispatch(this.iauiVerificationAction.dismissNotification());
	}
}
